<template>
  <v-flex xs12 mb5>
    <v-layout row wrap fluid>
      <v-flex xs12 md4 text-xs-center>
        <v-card>
          <v-list>
            <template>
              <v-subheader>
                Beszélgetések
              </v-subheader>

              <v-divider></v-divider>

              <v-list-tile
                v-for="(message, index) in messages"
                :key="index"
                avatar
                overflow
                height="90%"
                @click="loadMessage(message)"
              >
                <v-list-tile-avatar>
                  <img
                    v-if="message.user.profile_photo != null"
                    :src="
                      apiUrl +
                        '/uploads/profile_photos/' +
                        message.user.profile_photo
                    "
                    :alt="message.user.name"
                  />
                  <img
                    v-else
                    :src="apiUrl + '/uploads/profile_photos/default.png'"
                    :alt="message.user.name"
                  />
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ message.items[0].title }}
                    <sup>
                      <span
                        v-if="message.unread"
                        class="badge badge-sm badge-danger"
                      >
                        ÚJ!
                      </span>
                    </sup>
                  </v-list-tile-title>

                  <v-list-tile-sub-title>
                    <div>
                      <sub>
                        {{ message.created_at }}
                      </sub>
                    </div>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex xs12 md8 @show="conversationShow">
        <v-layout row wrap>
          <v-flex xs12 text-xs-left style="margin-bottom: 90px;">
            <v-card
              fullscreen
              flat
              v-for="(item, index) in messageItems"
              :key="index"
            >
              <v-layout row wrap>
                <v-flex :class="renderFlex(item)" mt-1>
                  <v-layout fill-height>
                    <v-flex
                      :class="renderAvatar(item)"
                      style="position:relative;"
                    >
                      <v-spacer></v-spacer>
                      <v-avatar
                        style="position:absolute; bottom: 0 !important;"
                      >
                        <img
                          v-if="item.user.profile_photo !== null"
                          :src="
                            apiUrl +
                              '/uploads/profile_photos/' +
                              item.user.profile_photo
                          "
                          :alt="item.user.name"
                        />
                        <img
                          v-else
                          :src="apiUrl + '/uploads/profile_photos/default.png'"
                          :alt="item.user.name"
                        />
                      </v-avatar>
                    </v-flex>

                    <v-flex :class="renderCardFlex(item)">
                      <div :class="renderName(item)" class="text-muted">
                        {{ item.user.name }}
                      </div>
                      <v-card :class="renderCard(item)" dark>
                        <div
                          class="conversationOther p-2"
                          v-html="item.message"
                        ></div>
                        <!-- <v-divider></v-divider>
                                                <div class="conversationMain pb-2"> {{ item.content_main }} </div> -->
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex
        xs12
        offset-md-4
        md8
        class="bottomMessageInput"
        :class="[sendInputShow ? '' : 'd-none']"
      >
        <v-layout fluid row wrap>
          <v-flex xs9 justify-center>
            <v-text-field
              v-model="newMessage"
              label="Új üzenet"
              placeholder="Új üzenet"
              solo
              clearable
            ></v-text-field>
          </v-flex>
          <v-flex xs3 text-left justify-center>
            <v-btn fab dark small color="cyan" @click="sendMessage">
              <v-icon dark>send</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import axios from "axios";

export default {
  components: {},
  data: function() {
    return {
      apiUrl: this.$store.getters.getApiUrl,
      userId: this.$store.getters.currentUser.id,
      messages: "",
      messageItems: "",
      newMessage: "",
      currentMessage: "",
      conversationShow: false,
      sendInputShow: false,
      messageSuccess: {
        show: false,
        message: "",
        timeout: 4500
      },
      messageError: {
        show: false,
        message: "",
        timeout: 4500
      }
    };
  },
  methods: {
    getMessages() {
      axios
        .post(this.$store.getters.getApiUrl + "/api/message/getMessages", {
          token: this.$store.getters.getToken,
          userId: this.$store.getters.currentUser.id
        })
        .then(response => {
          // console.log('messages-get-resp: ', response.data.messagesData);
          this.$data.messages = response.data.messagesData;
        })
        .catch(error => {
          if (error.length > 0) {
            // console.log('profile- error: ', error);
          }

          var v = this;
          setTimeout(function() {
            v.$data.loader = false;
          }, 1000);
        });
    },
    loadMessage(message) {
      // console.log(message);

      axios
        .post(
          this.$store.getters.getApiUrl + "/api/message/getMessageDetails",
          {
            token: this.$store.getters.getToken,
            userId: this.$store.getters.currentUser.id,
            messageId: message.id
          }
        )
        .then(response => {
          // console.log('messagesDetails-get-resp: ', response.data.messagesData);
          this.$data.messages = response.data.messagesData;
          this.$data.messageItems = response.data.messageItems;

          //After we load the messageDetails, show them
          this.$data.conversationShow = true;
          this.$data.sendInputShow = true;
          this.$data.currentMessage = message.id;
        })
        .catch(error => {
          if (error.length > 0) {
            // console.log('message- error: ', error);
          }

          var v = this;
          setTimeout(function() {
            v.$data.loader = false;
          }, 1000);
        });
    },
    renderFlex(item) {
      if (this.userId !== item.user.id) {
        return "xs12 sm8";
      } else {
        return "xs12 offset-sm4 sm8";
      }
    },
    renderCard(item) {
      if (this.userId !== item.user.id) {
        return "pilled mainGrey messageLeft text-black";
      } else {
        return "pilled mainLightBlue messageRight";
      }
    },
    renderCardFlex(item) {
      if (this.userId !== item.user.id) {
        return "xs10 order-xs2";
      } else {
        return "xs10 order-xs1";
      }
    },
    renderAvatar(item) {
      if (this.userId !== item.user.id) {
        return "xs2 order-xs1 text-xs-right mr-5 pr-3";
      } else {
        return "xs2 order-xs2 ml-2";
      }
    },
    renderName(item) {
      if (this.userId !== item.user.id) {
        return "text-xs-left";
      } else {
        return "text-xs-right";
      }
    },
    sendMessage() {
      axios
        .post(this.$store.getters.getApiUrl + "/api/message/sendMessage", {
          token: this.$store.getters.getToken,
          userId: this.$store.getters.currentUser.id,
          messageId: this.$data.currentMessage,
          newMessage: this.newMessage
        })
        .then(response => {
          // console.log('messages-send-resp: ', response.data.messagesData);
          this.$data.messages = response.data.messagesData;
          this.$data.messageItems = response.data.messageItems;

          //After we load the messageDetails, show them
          this.$data.conversationShow = true;
          this.$data.currentMessage = message.id;
          this.newMessage = ""; //Empty new message
        })
        .catch(error => {
          if (error.length > 0) {
            // console.log('profile- error: ', error);
          }

          var v = this;
          setTimeout(function() {
            v.$data.loader = false;
          }, 1000);
        });
    }
  },
  created: function() {
    this.getMessages();
  },
  mounted() {}
};
</script>
